import React, { useState } from 'react';
import './ClimateData.css';

const ClimateData = () => {
  const [activeTab, setActiveTab] = useState('seismic');

  // Seismic data - you can replace with real API later
  const seismicEvents = [
    { date: '2026-02-10', magnitude: 5.6, location: 'Portland Parish', depth: '10km' },
    { date: '2026-02-08', magnitude: 5.6, location: 'Portland Parish', depth: '10km' },
    { date: '2026-01-30', magnitude: 3.7, location: 'St. Andrew Parish', depth: '19km' },
    { date: '2026-01-28', magnitude: 3.6, location: 'St. Andrew Parish', depth: '17km' },
    { date: '2026-01-26', magnitude: 3.2, location: 'Portland Parish', depth: '21km' },
    { date: '2026-01-15', magnitude: 2.5, location: 'St. Andrew Parish', depth: '6km' }
  ];

const weatherAlerts = [
    { 
        type: 'Cold Weather Advisory', 
        severity: 'Moderate', 
        area: 'Blue Mountains & High Elevations', 
        until: 'Feb 11',
        description: 'Temperatures dropping to 8-10°C in mountain areas. Unseasonably cold air mass affecting the Caribbean. Protect crops and livestock.'
    },
    { 
        type: 'Agricultural Frost Warning', 
        severity: 'High', 
        area: 'Portland, St. Mary, St. Ann Highlands', 
        until: 'Feb 10',
        description: 'Frost possible in high-elevation farming areas. Coffee, produce, and ornamental crops at risk. Cover sensitive plants overnight.'
    },
    { 
        type: 'Marine Temperature Alert', 
        severity: 'Low', 
        area: 'North Coast Reefs', 
        until: 'Feb 12',
        description: 'Water temperatures dropped to 24.5°C, below normal 26-27°C range. Cold water stress possible for shallow corals. ENVIROTEK monitoring closely.'
    },
    { 
        type: 'Visitor Advisory', 
        severity: 'Low', 
        area: 'Kingston Metropolitan Area', 
        until: 'Feb 9',
        description: 'Cooler than usual temperatures 18-22°C (64-72°F). Tourists should pack light jackets for evenings. Not typical Caribbean weather!'
    }
  ];

  const reefHealth = {
    montegoBay: { health: 78, trend: 'improving', temp: '27.2°C', bleaching: 'Low Risk' },
    negril: { health: 82, trend: 'stable', temp: '26.8°C', bleaching: 'Low Risk' },
    ochoRios: { health: 71, trend: 'declining', temp: '28.1°C', bleaching: 'Medium Risk' }
  };

  const getHealthColor = (health) => {
    if (health >= 80) return '#10b981'; // green
    if (health >= 60) return '#f59e0b'; // orange
    return '#ef4444'; // red
  };

  return (
    <section id="climate-data" className="climate-data">
      <div className="container">
        <div className="climate-header">
          <h2>🌍 Jamaica Climate Intelligence</h2>
          <p>Real-time environmental monitoring powered by ENVIROTEK AI</p>
          <div className="last-updated">
            <span className="update-dot"></span>
            Last updated: {new Date().toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' })}
          </div>
        </div>

        <div className="climate-tabs">
          <button 
            className={`tab ${activeTab === 'seismic' ? 'active' : ''}`}
            onClick={() => setActiveTab('seismic')}
          >
            <span className="tab-icon">🌋</span>
            <span className="tab-label">Seismic Activity</span>
          </button>
          <button 
            className={`tab ${activeTab === 'weather' ? 'active' : ''}`}
            onClick={() => setActiveTab('weather')}
          >
            <span className="tab-icon">⛈️</span>
            <span className="tab-label">Weather Alerts</span>
          </button>
          <button 
            className={`tab ${activeTab === 'reef' ? 'active' : ''}`}
            onClick={() => setActiveTab('reef')}
          >
            <span className="tab-icon">🪸</span>
            <span className="tab-label">Reef Health</span>
          </button>
        </div>

        <div className="tab-content-wrapper">
          {activeTab === 'seismic' && (
            <div className="tab-content">
              <div className="seismic-layout">
                <div className="seismic-summary">
                  <h3>Last 30 Days Summary</h3>
                  <div className="summary-stats">
                    <div className="summary-stat">
                      <span className="stat-number">7</span>
                      <span className="stat-label">Total Events</span>
                    </div>
                    <div className="summary-stat">
                      <span className="stat-number">5.6</span>
                      <span className="stat-label">Largest Magnitude</span>
                    </div>
                    <div className="summary-stat">
                      <span className="stat-number">3.9</span>
                      <span className="stat-label">Avg Magnitude</span>
                    </div>
                  </div>
                </div>

                <div className="seismic-events">
                  <h3>Recent Earthquakes</h3>
                  <div className="events-table">
                    <table>
                      <thead>
                        <tr>
                          <th>Date</th>
                          <th>Magnitude</th>
                          <th>Location</th>
                          <th>Depth</th>
                        </tr>
                      </thead>
                      <tbody>
                        {seismicEvents.map((event, index) => (
                          <tr key={index}>
                            <td>{event.date}</td>
                            <td>
                              <span className={`magnitude magnitude-${Math.floor(event.magnitude)}`}>
                                {event.magnitude}
                              </span>
                            </td>
                            <td>{event.location}</td>
                            <td>{event.depth}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <p className="data-source">
                📡 Data from ENVIROTEK Seismic AI API
              </p>
            </div>
          )}

          {activeTab === 'weather' && (
            <div className="tab-content">
              <h3>Active Alerts</h3>
              <div className="weather-alerts">
                {weatherAlerts.length > 0 ? (
                  weatherAlerts.map((alert, index) => (
                    <div key={index} className={`alert-card severity-${alert.severity.toLowerCase()}`}>
                      <div className="alert-header">
                        <span className="alert-type">{alert.type}</span>
                        <span className={`alert-badge ${alert.severity.toLowerCase()}`}>
                          {alert.severity}
                        </span>
                      </div>
                      <p className="alert-area">📍 {alert.area}</p>
                      <p className="alert-description">{alert.description}</p>
                      <p className="alert-duration">Valid until {alert.until}</p>
                    </div>
                  ))
                ) : (
                  <div className="no-alerts">
                    <span className="no-alerts-icon">✅</span>
                    <p>No active weather alerts for Jamaica</p>
                  </div>
                )}
              </div>
              
              <div className="weather-forecast">
                <h4>7-Day Climate Outlook</h4>
                <p>Above-average temperatures expected through Feb 15. Increased rainfall likely Feb 16-18. Hurricane season begins June 1, 2026.</p>
              </div>
              
              <p className="data-source">
                📡 ENVIROTEK Weather AI • Predictions accurate within 2°C
              </p>
            </div>
          )}

          {activeTab === 'reef' && (
            <div className="tab-content">
              <h3>Coral Reef Monitoring Stations</h3>
              <div className="reef-grid">
                {Object.entries(reefHealth).map(([location, data]) => (
                  <div key={location} className="reef-card">
                    <h4>{location.replace(/([A-Z])/g, ' $1').trim()}</h4>
                    <div className="reef-health-bar">
                      <div 
                        className="reef-health-fill" 
                        style={{ 
                          width: `${data.health}%`,
                          backgroundColor: getHealthColor(data.health)
                        }}
                      />
                    </div>
                    <p className="reef-percentage" style={{ color: getHealthColor(data.health) }}>
                      {data.health}% Healthy
                    </p>
                    <div className="reef-stats">
                      <div className="reef-stat">
                        <span className={`trend trend-${data.trend}`}>
                          {data.trend === 'improving' ? '📈' : data.trend === 'stable' ? '➡️' : '📉'} 
                          {data.trend}
                        </span>
                      </div>
                      <div className="reef-stat">
                        <span className="temp">🌡️ {data.temp}</span>
                      </div>
                      <div className="reef-stat">
                        <span className={`bleaching-risk ${data.bleaching.replace(' ', '-').toLowerCase()}`}>
                          {data.bleaching}
                        </span>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
              
              <div className="reef-info">
                <h4>🔬 How We Monitor</h4>
                <p>ENVIROTEK AI analyzes underwater images to detect bleaching before it's visible to the human eye. Early warnings allow tour operators to close stressed areas, giving coral time to recover.</p>
              </div>
              
              <p className="data-source">
                📡 ENVIROTEK Marine AI 
              </p>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default ClimateData;